<template>
  <div class="container-fluid">
    <div v-if="chat._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ chat.packageTitle }}</h3>
            <p class="text-center">{{ chat.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات ایموجی</h4>
          </div>
          <div class="widget-body">
            <form id="chatForm" class="form-horizontal">
              <!-- chat english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام پکیج</label>
                <div class="col-lg-6">
                  <input type="text" name="packageTitle" class="form-control" :value="chat.packageTitle" />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت ایموجی</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="chat.isAvailable">فعال</option>
                    <option value="false" :selected="!chat.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ایموجی دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" id="" :checked="chat.isDefault" />
                </div>
              </div>

              <div class="em-separator separator-dashed"></div>
              <!-- chat english name -->
              <div class="widget-header no-actions d-flex align-items-center">
                <h4>پیام ها</h4>
              </div>
              <div
                v-for="(message, index) of messages"
                :key="index"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پیام {{ index + 1 }}</label>
                <div class="col-lg-6">
                  <input type="text" name="chatName" class="form-control" v-model="messages[index]" />
                </div>
                <button type="button" class="btn btn-gradient-01" @click="deleteMessage(index)">حذف پیام</button>
              </div>
              <button type="button" class="btn btn-gradient-04" @click="newMessage">پیام جدید</button>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/chats">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chatService from '../../../../services/chat';
export default {
  name: 'chatdetail',
  data() {
    return {
      chat: {},
      messages: [],
    };
  },
  created() {
    this.getchat();
  },
  methods: {
    async getchat() {
      try {
        const chat = await chatService.findChatById(this.$route.query.id);
        console.log(chat);
        this.chat = chat;
        this.messages = chat.messages;
      } catch (err) {
        console.log(err);
      }
    },

    newMessage() {
      this.messages.push('');
    },
    deleteMessage(index) {
      this.messages.splice(index, 1);
    },

    async save() {
      const form = document.getElementById('chatForm');
      const body = {
        _id: this.chat._id,
        packageTitle: form.packageTitle.value,
        isAvailable: form.isAvailable.value == 'true',
        isDefault: form.isDefault.checked,
        messages: this.messages.filter(a => a != ''),
      };
      try {
        await chatService.updateChat(body);
        this.getchat();
        window.notif({ isError: false, mssg: 'بروز رسانی انجام شد' });
      } catch (err) {
        console.log(err);
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }

      console.log(body);
    },
  },
};
</script>
